var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.205 3.205v25.59h25.59v-25.59h-25.59zM27.729 4.271v4.594l-7.023 10.131-4.815-3.805-5.356 7.499-3.162-2.108-3.101 3.615v-19.927h23.457zM4.271 27.729v-1.893l3.296-3.842 3.235 2.157 5.306-7.428 4.827 3.814 6.793-9.8v16.992h-23.457z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph2);
export default __webpack_public_path__ + "static/media/graph2.8e371eb00073d227fedb2ee1b4021a28.svg";
export { ForwardRef as ReactComponent };